import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';

interface AdminContextType {
  isAdminMode: boolean;
  setAdminMode: (mode: boolean) => void;
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

export const AdminProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAdminMode, setAdminMode] = useState<boolean>(false);
  
  useEffect(() => {
    if (isAdminMode) {
      document.documentElement.classList.add('admin-theme');
    } else {
      document.documentElement.classList.remove('admin-theme');
    }
  }, [isAdminMode]);
  
  return (
    <AdminContext.Provider value={{ 
      isAdminMode, 
      setAdminMode 
    }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = (): AdminContextType => {
  const context = useContext(AdminContext);
  if (context === undefined) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};
